<template>
  <div class="home">
    <!-- <NavBar /> -->
    <HeroTab />
    <div class="section-wrapper mission-wrapper">
      <div class="mission-section">
        <div class="section-content">
          <h2>Our Mission</h2>
          <p>
            At Riddhi, we offer unbiased and honest investment advice, tailored
            plans, and suitable products to help our clients achieve their
            financial dreams.
          </p>
        </div>
      </div>
    </div>

    <div class="section-wrapper why-wrapper">
      <div class="why-riddhi">
        <h2>Why Riddhi</h2>
        <div class="why-content">
          <div class="principle-card">
            <h3>Person Before Finance</h3>
            <p>
              Investment advisory falls under the domain of personal finance.
              Personal Finance = Person + Finance. Here always, Person comes
              before Finance.
            </p>
          </div>

          <div class="principle-card">
            <h3>Understanding You</h3>
            <p>
              We believe that personal finance is about people, not just
              numbers. No two individuals are the same, we all have unique pasts
              and experiences with money that shape our financial habits.
            </p>
          </div>

          <div class="principle-card">
            <h3>Personalized Approach</h3>
            <p>
              We listen carefully to understand your financial situation, goals,
              and dreams. By identifying your financial shortcomings and
              developing strategies to address them, we provide personalized
              investment advice that aligns with your individual needs and
              circumstances.
            </p>
          </div>

          <div class="principle-card">
            <h3>Balanced Growth</h3>
            <p>
              At Riddhi, our goal is to help you achieve your future goals while
              maintaining a comfortable lifestyle. Our tailored investment
              advice ensures that your financial plan strikes a balance between
              your current needs and future goals.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="section-wrapper contact-wrapper">
      <div class="contact-section">
        <h2>Get in Touch</h2>
        <div class="contact-grid">
          <div class="contact-info">
            <div class="contact-item">
              <i class="fas fa-phone"></i>
              <p>+91 90031 98036</p>
            </div>
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <p>India, Tamilnadu, Chennai</p>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <p>support@riddhi.co.in</p>
            </div>
          </div>

          <div class="social-links">
            <!-- eslint-disable-next-line prettier/prettier -->
            <a href="https://www.instagram.com/riddhisangeetha/ " target="_blank" rel="noopener" class="social-link">
              <i class="fab fa-instagram"></i>
            </a>

            <!-- eslint-disable-next-line prettier/prettier -->
            <a href="https://x.com/riddhisangeetha" target="_blank" rel="noopener" class="social-link">
              <i class="fab fa-x-twitter"></i>
            </a>

            <!-- eslint-disable-next-line prettier/prettier -->
            <a href="https://www.facebook.com/riddhisangeetha" target="_blank" rel="noopener" class="social-link">
              <i class="fab fa-facebook"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import NavBar from "@/components/NavBar.vue";
import HeroTab from "@/components/HeroTab.vue";

export default {
  name: "HomeView",
  components: {
    // NavBar,
    HeroTab,
  },
};
</script>

<style scoped>
.content {
  padding: 40px 20px;
  max-width: 100%;
  margin: 0 auto;
}

.section-wrapper {
  position: relative;
  padding: 5rem 0;
}

.mission-wrapper {
  background: #e2eafc;
}

/* .mission-wrapper::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #072ac8, #1971c9);
} */

.why-wrapper {
  background-color: #f6f2f1;
}

/* .why-wrapper::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #c76c55, #e97e1b);
} */

.contact-wrapper {
  background: linear-gradient(135deg, #1971c9 0%, #072ac8 100%);
}

.mission-section {
  background: white;
  padding: 4rem 2rem;
  margin: 0 auto;
  max-width: 1200px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.mission-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient
    (circle at top right, rgba(7, 42, 200, 0.05) 0%, transparent 70%);
  z-index: 1;
}

.section-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 2;
}

.mission-section h2 {
  color: #072ac8;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.mission-section p {
  color: #2c3e50;
  font-size: 1.2rem;
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto;
  padding: 0 1rem;
}

.why-riddhi {
  padding: 4rem 0;
  max-width: 1200px;
  margin: 0 auto;
}

.why-riddhi h2 {
  color: #2c3e50;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
}

.why-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.principle-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.principle-card:hover {
  transform: translateY(-5px);
}

.principle-card h3 {
  color: #072ac8;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.principle-card h3::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50%;
  height: 4px;
  background-color: #e97e1b;
}

.principle-card p {
  color: #4a5568;
  line-height: 1.8;
  font-size: 1.1rem;
}

.contact-section {
  max-width: 1200px;
  margin: 0 auto;
}

.contact-section h2 {
  color: white;
  margin-bottom: 2rem;
  font-size: 2rem;
}

.contact-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.1rem;
  color: white;
}

.contact-item i {
  color: white;
  font-size: 1.5rem;
  width: 24px;
}

.social-links {
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
}

.social-link {
  color: white;
  font-size: 1.8rem;
  transition: transform 0.3s, color 0.3s;
}

.social-link:hover {
  transform: translateY(-3px);
  color: #e9ecef;
}

@media (min-width: 768px) {
  .contact-grid {
    flex-direction: row;
    justify-content: center;
    gap: 4rem;
  }

  .contact-info {
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .mission-section,
  .why-riddhi {
    padding: 2rem 1rem;
  }

  .mission-section h2,
  .why-riddhi h2 {
    font-size: 2rem;
  }

  .why-content {
    grid-template-columns: 1fr;
  }

  .principle-card {
    padding: 1.5rem;
  }
}
</style>
